import { BitmapImage2D } from '../image/BitmapImage2D';
import { BitmapImageCube } from '../image/BitmapImageCube';
var DefaultStageFactory = /** @class */ (function () {
    function DefaultStageFactory() {
    }
    DefaultStageFactory.prototype.createImage2D = function (width, height, transparent, fillColor, powerOfTwo) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = null; }
        if (powerOfTwo === void 0) { powerOfTwo = true; }
        return new BitmapImage2D(width, height, transparent, fillColor, powerOfTwo);
    };
    DefaultStageFactory.prototype.createImageCube = function (size, transparent, fillColor) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = null; }
        return new BitmapImageCube(size, transparent, fillColor);
    };
    return DefaultStageFactory;
}());
export { DefaultStageFactory };
